import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogService, BlogPost, normalizeImagePath } from '../../services/blogService';

const FeaturedNews: React.FC = () => {
  const [article, setArticle] = useState<BlogPost | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const data = await blogService.fetchFeaturedNews();
        setArticle(data);
      } catch (err) {
        console.error('Error fetching featured news:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFeatured();
  }, []);

  if (loading) {
    return (
      <div className="card h-100">
        <div className="card-body d-flex align-items-center justify-content-center">
          <div className="spinner-border spinner-border-sm text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!article) {
    return null; // Don't show section if no news
  }

  return (
    <div className="card h-100 shadow-sm">
      {article.featuredImage && (
        <img
          src={normalizeImagePath(article.featuredImage.path)}
          alt={article.featuredImage.alt || article.title}
          className="card-img-top"
          style={{ height: '180px', objectFit: 'cover' }}
        />
      )}
      <div className="card-body d-flex flex-column">
        <h5 className="card-subtitle text-muted mb-2">
          <i className="fas fa-newspaper me-2"></i>In the News
        </h5>
        <div className="mb-2">
          <span className="badge bg-warning text-dark">{article.sourceName}</span>
        </div>
        <h4 className="card-title">{article.title}</h4>
        <p className="card-text flex-grow-1 text-muted">{article.excerpt}</p>
        <Link to={`/news/${article.slug}`} className="btn btn-outline-primary">
          Read More
        </Link>
      </div>
    </div>
  );
};

export default FeaturedNews;
